import { PermitActions } from '@contracts/permit/PermitActions';
import { type OrderListing } from '@src/orders/domain/OrderList';
import type { PermitSummary } from '@src/orders/domain/PermitSummary';

export interface PermitActionRules {
  canReorder: boolean;
  canCancel: boolean;
  shouldCompleteForm: boolean;
  canProcessWithJurisdiction: boolean;
  canModifyStateApplication: boolean;
  canAmend: boolean;
  canModifyWithJurisdiction: boolean;
  canCompleteApplication: boolean;
  canKeepAsIs: boolean;
  canReopenForCorrection: boolean;
  canView: boolean;
  canReplaceType: boolean;
}

export class PermitActionRulesService {
  static computeActionRules(
    permit: PermitSummary,
    order: OrderListing,
  ): PermitActionRules {
    return {
      canReorder: permit.canDo(PermitActions.REORDER),
      canCancel: permit.canDo(PermitActions.CANCEL),
      shouldCompleteForm:
        permit.canDo(PermitActions.COMPLETE_FORM) &&
        !permit.hasFilledAllRequiredFields(),
      canProcessWithJurisdiction:
        permit.canDo(PermitActions.PROCESS_WITH_JURISDICTION) &&
        permit.hasFilledAllRequiredFields(),
      canModifyStateApplication: permit.canDo(
        PermitActions.MODIFY_STATE_APPLICATION,
      ),
      canAmend: permit.canDo(PermitActions.AMEND),
      canModifyWithJurisdiction: permit.canDo(
        PermitActions.MODIFY_WITH_JURISDICTION,
      ),
      canCompleteApplication:
        permit.canDo(PermitActions.COMPLETE_APPLICATION) &&
        order.isBillable() &&
        (!permit.isSelfIssued || permit.hasFilledAllRequiredFields()),
      canKeepAsIs: permit.canDo(PermitActions.KEEP_AS_IS),
      canReopenForCorrection: permit.canDo(PermitActions.REOPEN_FOR_CORRECTION),
      canView: permit.canDo(PermitActions.VIEW),
      canReplaceType: permit.canDo(PermitActions.REPLACE_TYPE),
    };
  }
}
